import * as ActionTypes from '../constants/actionTypes'
import { apiClient } from '../lib';
import store from '../store'
import moment from 'moment'
import {waitForOrganization} from './.helpers'
export const fetch = async(params = {})=>{
  await waitForOrganization()
  const response = await apiClient.organizations.notifications.fetch(params)

  let data = {};
  if(response && response.data){
    if(response.data.id){
      data[response.data.id] = response.data
    }else{
      data = response.data.reduce((acc, item)=>{
        acc[item.id] = item
        return acc;
      }, {})
    }
    
    store.dispatch({ 
      type: ActionTypes.FETCH_NOTIFICATIONS,
      payload: data
    })
  }
}

const fetching = {}
export const safeFetchByID = async(params = {})=>{
  if(!fetching[params.id] && !store.getState().accounts[params.id]){
    fetching[params.id] = true
    await fetch({id: params.id})
    fetching[params.id] = false
  }
}

export const markAsViewed = async(id, {local}={}) => {
  if(!local){
    await apiClient.organizations.notifications.markAsViewed({
      id
    })
  }
  
  const data = {...store.getState().notifications}
  data[id] = {
    ...data[id],
    viewedAt: moment().format()
  }
  store.dispatch({ 
    type: ActionTypes.FETCH_NOTIFICATIONS,
    payload: data
  })
}


// WEBPACK FOOTER //
// ./src/actions/notifications.js